import React from 'react';
import { ActionButton } from '@fabric-ui/components/Table';
import { StarFull, StarLine } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box } from '@mui/material';
import { App } from '../../types/sideBar.types';
import { Link } from '../../utils/AvRouter';

const starFullIcon = <StarFull style={{ color: 'var(--color-yellow-150)', ...iconSize(20) }} />;
const starLineIcon = <StarLine style={iconSize(20)} />;

interface AppItemProps extends App {
  isSelected: boolean;
  isFavorite?: boolean;
  showDescription?: boolean;
  to?: string;
  toggleFavoriteApp?: () => void;
  appIconSize?: number;
  isDropdownItem?: boolean;
}
export const AppItem: React.FC<AppItemProps> = ({
  name,
  icon,
  iconFull,
  iconDropdown,
  appIconSize,
  isSelected,
  to,
  showDescription,
  isFavorite = true,
  toggleFavoriteApp,
  description,
  isDropdownItem = false,
}) => {
  const displayIcon = isDropdownItem && iconDropdown ? iconDropdown : isSelected && iconFull ? iconFull : icon;

  return (
    <Link to={to}>
      <Box className="app-item-container" sx={theme => appIconStyle(theme, isSelected, appIconSize, isDropdownItem)}>
        {toggleFavoriteApp &&
          ActionButton(
            isFavorite ? 'Remove from favorite' : 'Add to Favorite',
            toggleFavoriteApp,
            isFavorite ? starFullIcon : starLineIcon
          )}
        <Box sx={{ borderRadius: '8px', position: 'relative' }}>
          <Box className="icon-container">{displayIcon}</Box>
        </Box>
        <Box sx={{ ...flex.col }}>
          <Box sx={{ fontWeight: 600 }}>{name}</Box>
          {showDescription && <Box sx={{ fontWeight: 400, color: 'var(--color-content-base-secondary)' }}>{description}</Box>}
        </Box>
      </Box>
    </Link>
  );
};
export const appIconStyle = (theme, isSelected, appIconSize = 22, isDropdownItem = false) => {
  const hoverColor = isDropdownItem ? undefined : 'var(--color-surface-nav-topBar-hover)';
  const selectedColor = isDropdownItem ? 'var(--color-surface-list-focus)' : 'var(--color-surface-nav-topBar-active)';
  const textColor = isDropdownItem ? 'var(--color-content-base-primary)' : 'var(--color-content-immutable-white)';

  return {
    ...flex.center,
    pl: '4px',
    pr: '12px',
    py: '4px',
    gap: '8px',
    borderRadius: '10px',
    cursor: 'pointer',
    color: textColor,
    transition: theme.transitions.create(['opcaity', 'background-color'], {
      duration: theme.transitions.duration.short,
    }),
    svg: {
      ...iconSize(appIconSize),
    },
    '.icon-container': {
      p: '5px',
      borderRadius: '8px',
      ...flex.center,
    },
    ':hover': {
      backgroundColor: hoverColor,
      color: textColor,
    },
    ...(isSelected
      ? {
          backgroundColor: selectedColor,
          color: textColor,
          ':hover': {
            backgroundColor: hoverColor,
            color: textColor,
          },
        }
      : {}),
  };
};

export const appBarItemSelectedStyle = {
  svg: {
    color: 'var(--color-content-immutable-white)',
    ...iconSize(22),
  },
  borderColor: 'transparent',
  background: 'var(--color-surface-nav-topBar-active)',
};
export const appBarItemHoveredStyle = {
  ':hover': {
    background: 'var(--color-surface-nav-topBar-hover)',
    color: 'var(--color-content-immutable-white)',
  },
};
